module.exports = "/static-assets/feed-ui/_next/static/images/500kViews-e9288164e3c6a958e19dfdb88f663184.png";